import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['category', 'project']),
        getByCategory: state => category => {
          return state.objs.filter(ocp => ocp.category === category);
        },
        getByProject: state => project => {
          return state.objs.filter(ocp => ocp.project === project);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['category', 'project'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['category', 'project'])
    },
}